import React, { useState } from 'react'
import SuccessAlert from '../../components/Alerts/SuccessAlert';
import FailAlert from '../../components/Alerts/FailAlert';
import statesData from '../../data/yemen-states.json';
import { useMutation } from '@apollo/client';
import { CreateDeliveryMethod } from '../../graphql';
import { MdClose } from 'react-icons/md'
import { StoresProps } from '../../types';
import { t } from 'i18next';

interface AddShippingPopupProps {
  setAddShippingPopup: React.Dispatch<React.SetStateAction<boolean>>
  selectedStore: StoresProps | null
}

const AddShippingPopup = ({ setAddShippingPopup, selectedStore }: AddShippingPopupProps) => {

  const [success, setSuccess] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [fail, setFail] = useState(false);
  const [failMsg, setFailMsg] = useState("");

  // Create
  const [createDeliveryMethod, { error, loading }] = useMutation(CreateDeliveryMethod, {
    update: (cache, { data: { createDeliveryMethod } }) => {
      cache.modify({
        fields: {
          allDeliveryMethods(existedDeliveryMethods = []) {
            return [...existedDeliveryMethods, createDeliveryMethod];
          }
        }
      })
    }
  });

  const [cities, setCities] = useState(() =>
    statesData.map(city => ({ ...city, selected: false }))
  );

  const [name, setName] = useState("");
  const [price, setPrice] = useState(0);
  const [cashOnDelivery, setCashOnDelivery] = useState(false);
  const [time, setTime] = useState("");

  const handleChange = (cityId: number) => {
    setCities(prevCities =>
      prevCities.map(city =>
        city.id === cityId ? { ...city, selected: !city.selected } : city
      )
    );
  };

  const handleCheckAll = (event: any) => {
    const isChecked = event.target.checked;
    setCities(prevCities =>
      prevCities.map(city => ({ ...city, selected: isChecked }))
    );
  };

  const Submit = async (e: any) => {
    e.preventDefault();
    if (name === "") {
      setFailMsg(t('NameRequire'));
      setFail(true);
      return
    }

    if (price <= 0) {
      setFailMsg(t('invalid cost value'));
      setFail(true);
      return
    }

    if (time === "") {
      setFailMsg(t('emptyDeliveryTime'));
      setFail(true);
      return
    }

    const selectedCities = cities.filter((city) => city.selected !== false);
    const citiesToStore: string[] = [];
    selectedCities.map((city: any) => {
      citiesToStore.push(city.name)
    })

    if (citiesToStore.length === 0) {
      setFailMsg(t('emptyCityAlert'));
      setFail(true);
      return
    }

    await createDeliveryMethod({
      variables: {
        content: {
          estimatedTime: time,
          idStore: selectedStore?.id,
          name: name,
          paymentWhenReceiving: cashOnDelivery,
          price: price,
          pricePaymentWhenReceiving: price,
          cities: citiesToStore
        }
      }
    })


    if (!error) {
      setSuccessMsg(t("createSuccess"));
      setSuccess(true);

      // CLear the form
      setName("");
      setPrice(0);
      setTime("");

      setAddShippingPopup(false)
    }
  }

  return (
    <div className='fixed top-0 left-0 z-50 flex items-center justify-center w-full min-h-screen bg-gray-900/10 backdrop-blur-md'>
      {success && <SuccessAlert success={success} setSuccess={setSuccess} successMsg={successMsg} />}

      {fail && <FailAlert fail={fail} setFail={setFail} failMsg={failMsg} />}

      <div className='w-5/6 p-2 overflow-y-auto bg-white border h-[80vh] rounded-md sm:w-4/6 md:w-3/6'>
        <div className='flex justify-end py-2 text-gray-600'>
          <div onClick={() => setAddShippingPopup(false)} className='cursor-pointer'>
            <MdClose size={20} />
          </div>
        </div>

        <div>
          {
            loading &&
            <div className='absolute left-0 z-30 flex items-center justify-center w-full h-full py-10 bg-white/70'>
              <svg aria-hidden="true" className="w-8 h-8 mr-2 text-gray-200 animate-spin fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
              </svg>
            </div>
          }
          <div className='mb-2'>
            <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900">{t('Shipping Option Name')}</label>
            <input type="text" id="name" value={name} onChange={(e) => setName(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary outline-none block w-full p-2.5" placeholder={t('name')} required />
          </div>

          <div className='mb-2'>
            <label htmlFor="cost" className="block mb-2 text-sm font-medium text-gray-900">{t('cost')}</label>
            <input type="number" id="cost" value={price} onChange={(e) => setPrice(parseInt(e.target.value) || 0)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary outline-none block w-full p-2.5" placeholder={t('cost')} required />
          </div>

          <div className="mb-2">
            <label htmlFor="time" className="block mb-2 text-sm font-medium text-gray-900">{t('expectedShippingTime')}</label>
            <textarea id="time" value={time} onChange={(e) => setTime(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary outline-none block w-full p-2.5" placeholder={t('expectedShippingTime')} />
          </div>

          <div className="relative flex items-center mb-2">
            <div className='flex'>
              <input type="checkbox" checked={cashOnDelivery} onChange={() => setCashOnDelivery(!cashOnDelivery)} className="relative w-4 h-4 border border-gray-300 rounded appearance-none peer bg-gray-50 checked:bg-primary checked:border-0" />
              <svg className="absolute w-4 h-4 p-0.5 text-white hidden peer-checked:block pointer-events-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </div>

            <label className="mx-2 font-medium text-gray-800">{t('payingOnDelivery')}</label>
          </div>

          <div className='mb-2'>
            <label className="block mb-2 text-sm font-medium text-gray-900">{t('shippingCities')}</label>
            <div className="py-2 mt-2 overflow-y-auto bg-white border border-gray-300 rounded-md h-52">
              <div className="flex flex-col p-3 text-sm">
                <div className='relative flex gap-2 pb-2'>
                  <div className='flex'>
                    <input type="checkbox" onChange={handleCheckAll} className="relative w-4 h-4 border border-gray-300 rounded appearance-none peer bg-gray-50 checked:bg-primary checked:border-0" />
                    <svg className="absolute w-4 h-4 p-0.5 text-white hidden peer-checked:block pointer-events-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  </div>
                  <label htmlFor='all' className="w-full mx-1">
                    {t('checkAll')}
                  </label>
                </div>

                {cities.map((state: any, index: any) => (
                  <div key={index} className='flex items-center gap-3 py-2 my-px text-gray-600 capitalize transition-colors duration-300 transform cursor-pointer hover:bg-gray-100'>
                    <div className='flex'>
                      <input type="checkbox" onChange={() => handleChange(state.id)} checked={state.selected} id={`city${index}`} className="relative w-4 h-4 border border-gray-300 rounded appearance-none peer bg-gray-50 checked:bg-primary checked:border-0" />
                      <svg className="absolute w-4 h-4 p-0.5 text-white hidden peer-checked:block pointer-events-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </div>
                    <label htmlFor={`city${index}`} className="w-full mx-1">
                      {state.name}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className='flex justify-end pt-5'>
            <button onClick={(e) => { Submit(e) }} className='inline-flex items-center justify-center w-full px-4 py-2.5 overflow-hidden text-sm text-white transition-colors duration-300 bg-primary rounded-lg shadow sm:w-auto my-2 md:my-0 hover:bg-primaryHover'>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 2H8c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM8 16V4h12l.002 12H8z"></path>
                <path d="M4 8H2v12c0 1.103.897 2 2 2h12v-2H4V8zm11-2h-2v3h-3v2h3v3h2v-3h3V9h-3z"></path>
              </svg>

              <span className="mx-2">
                {t('save')}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddShippingPopup